"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const customStyles = {
    control: (base, state) => (Object.assign(Object.assign({}, base), { position: "relative", zIndex: 3, minWidth: "160px", height: "auto", minHeight: "32px", borderRadius: "6px", borderColor: "#D9D9D9", borderWidth: "1px", backgroundColor: "#FBFBFD", boxShadow: "none", "&:hover": {
            borderColor: "#D9D9D9",
        } })),
    valueContainer: (base) => (Object.assign(Object.assign({}, base), { padding: "2px 8px", minHeight: "32px", height: "auto", flexWrap: "wrap", gap: "2px" })),
    multiValue: (base) => (Object.assign(Object.assign({}, base), { backgroundColor: "#F4F4F5", borderRadius: "4px", margin: "2px 0" })),
    multiValueLabel: (base) => (Object.assign(Object.assign({}, base), { color: "#3F3F46", fontSize: "14px", fontFamily: "Noto Sans JP", padding: "2px 6px" })),
    multiValueRemove: (base) => (Object.assign(Object.assign({}, base), { color: "#71717A", cursor: "pointer", "&:hover": {
            backgroundColor: "#E4E4E7",
            color: "#3F3F46",
        } })),
    input: (base) => (Object.assign(Object.assign({}, base), { margin: "0", padding: "0" })),
    singleValue: (base) => (Object.assign(Object.assign({}, base), { color: "#3F3F46", fontSize: "14px", fontWeight: 700 })),
    menu: (base) => (Object.assign(Object.assign({}, base), { position: "absolute", zIndex: 999, backgroundColor: "white", width: "100%", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" })),
    menuList: (base) => (Object.assign(Object.assign({}, base), { backgroundColor: "white", padding: "4px 0" })),
    option: (base, state) => (Object.assign(Object.assign({}, base), { backgroundColor: state.isFocused ? "#f0f0f0" : "white", color: "#3F3F46", fontSize: "14px", fontFamily: "Noto Sans JP", padding: "8px 12px", cursor: "pointer" })),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (base) => (Object.assign(Object.assign({}, base), { padding: "0 8px", color: "#3F3F46", "&:hover": {
            color: "#3F3F46",
        } })),
    clearIndicator: (base) => (Object.assign(Object.assign({}, base), { padding: "0 4px", color: "#71717A", "&:hover": {
            color: "#3F3F46",
        } })),
};
const defaultProps = {
    styles: customStyles,
    isSearchable: false,
};
const ConditionSelect = (_a) => {
    var { wrapperClassName, styles } = _a, props = __rest(_a, ["wrapperClassName", "styles"]);
    const mergedStyles = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, customStyles), styles)), [styles]);
    return (react_1.default.createElement("div", { className: wrapperClassName, style: {
            position: "relative",
            zIndex: 20,
        } },
        react_1.default.createElement(react_select_1.default, Object.assign({}, defaultProps, props, { menuPortalTarget: document.body, styles: mergedStyles }))));
};
exports.default = ConditionSelect;
